<template>
  <div id="modalCreateEditQuestion" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Questão</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-1">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Pergunta: <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  :class="{ 'is-invalid': v$.question.text.$errors.length }"
                  placeholder="Pergunta"
                  v-model="v$.question.text.$model"
                />
                <span
                  v-if="v$.question.text.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.question.text.minLength.$invalid"
                  class="invalid-feedback"
                >
                  A pergunta deve possuir pelo menos
                  {{ v$.question.text.minLength.$params.min }} caracteres
                </span>
              </div>
              <div v-if="!this.questionId" class="col-sm-12">
                <p>
                  Quantidade de Alternativas: <span class="text-danger">*</span>
                </p>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="amountAnswer1"
                    v-model="v$.amountAnswer.$model"
                    value="2"
                  />
                  <label class="form-check-label" for="amountAnswer1">
                    2
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="amountAnswer2"
                    v-model="v$.amountAnswer.$model"
                    value="4"
                  />
                  <label class="form-check-label" for="amountAnswer2">
                    4
                  </label>
                </div>
              </div>
              <div
                v-for="(answer, index) in question.answers"
                :key="index"
                class="col-sm-6"
              >
                <label class="form-label">
                  Alternativa {{ index + 1 }}:
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  placeholder="Pergunta"
                  v-model="v$.question.answers.$model[index].text"
                />
              </div>
              <div class="col-sm-12 mb-0">
                <p>Alternativa Correta: <span class="text-danger">*</span></p>
                <div
                  v-for="(answer, index) in question.answers"
                  :key="index"
                  class="form-check form-check-inline"
                >
                  <input
                    type="radio"
                    class="form-check-input"
                    :id="`answer${index}`"
                    name="answer"
                    v-model="v$.question.answerCorrect.$model"
                    :value="index"
                  />
                  <label class="form-check-label" :for="`answer${index}`">
                    Alternativa {{ index + 1 }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, helpers } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditQuestionModal',

  props: {
    typeQuestion: {
      type: String,
      required: true,
      validator(value) {
        return ['lesson', 'course'].indexOf(value) !== -1
      },
    },
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      default: null,
    },
    lessonId: {
      type: String,
      default: null,
    },
    questionId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      amountAnswer: '4',
      question: {
        text: '',
        answers: [
          {
            text: '',
            isCorrect: 0,
          },
          {
            text: '',
            isCorrect: 0,
          },
          {
            text: '',
            isCorrect: 0,
          },
          {
            text: '',
            isCorrect: 0,
          },
        ],
        answerCorrect: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.questionId ? 'Atualizar' : 'Cadastrar'
    },
  },

  watch: {
    'amountAnswer': {
      handler(newVal, oldVal) {
        if (newVal === '2') {
          this.question.answers.splice(2, 2)
          this.question.answerCorrect = ''
        } else {
          this.question.answers.push(
            {
              text: '',
              isCorrect: 0,
            },
            {
              text: '',
              isCorrect: 0,
            },
          )
          this.question.answerCorrect = ''
        }
      },
    },
    'question.answerCorrect': {
      handler(newVal, oldVal) {
        this.question.answers = this.question.answers.map((answer, index) => {
          return {
            ...answer,
            isCorrect: index === newVal ? 1 : 0,
          }
        })
      },
    },
  },

  methods: {
    async getQuestion() {
      try {
        this.question = await this.$store.dispatch('getQuestion', {
          typeQuestion: this.typeQuestion,
          courseId: this.courseId,
          moduleId: this.moduleId,
          lessonId: this.lessonId,
          questionId: this.questionId,
        })

        this.answerCorrect = this.question.answers.findIndex(
          (answer) => answer.isCorrect === '1',
        )

        this.question = {
          ...this.question,
          answerCorrect: this.answerCorrect,
        }

        showModal('modalCreateEditQuestion')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.questionId) {
            response = await this.$store.dispatch('updateQuestion', {
              typeQuestion: this.typeQuestion,
              courseId: this.courseId,
              moduleId: this.moduleId,
              lessonId: this.lessonId,
              questionId: this.questionId,
              question: this.question,
            })
          } else {
            response = await this.$store.dispatch('saveQuestion', {
              typeQuestion: this.typeQuestion,
              courseId: this.courseId,
              moduleId: this.moduleId,
              lessonId: this.lessonId,
              question: this.question,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      amountAnswer: {
        required,
      },
      question: {
        text: {
          required,
          minLength: minLength(4),
        },
        answers: {
          $each: helpers.forEach({
            text: { required },
          }),
        },
        answerCorrect: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.questionId) {
      this.getQuestion()
    } else {
      showModal('modalCreateEditQuestion')
    }
  },
}
</script>
